// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__2Ue3Z","container":"layout_container__3V799"};